import { openPromptModal } from "./libs/prompt_modal";
import { openCopyReportModal } from "./libs/copy_report_modal";

/**
 * Load and run the Circle Progress Bar animation
 */
function loadCircleProgressBar() {
    // Get all SVG radial progress
    $("svg.radial-progress").each(function () {
        const speed = $(this).data("speed"); // Get the speed for the animation (same for each circle-treatment)
        // Get all circle treatment
        $(this)
            .find($(".circle-treatment"))
            .each(function () {
                const percent = $(this).data("percentage"); // Get percentage of progress
                const radius = $(this).find($("circle.complete")).attr("r"); // Get radius of the svg"s circle.complete
                const circumference = 2 * Math.PI * radius; // Get circumference (2πr)
                const strokeDashOffset =
                    circumference - (percent * circumference) / 100; // Get stroke-dashoffset value based on the percentage of the circumference
                $(this).find($("circle.complete")).css({
                    "stroke-dashoffset": circumference,
                    "stroke-dasharray": circumference,
                }); // Set circle
                $(this)
                    .find($("circle.complete"))
                    .animate({ "stroke-dashoffset": strokeDashOffset }, speed); // Transition progress according to the speed
            });
    });
}

/**
 * Load and run the Balance animation
 */
function loadSeeSawBalance() {
    // Get all SVG balance
    $("svg.balance").each(function () {
        const speed = $(this).data("speed"); // Get the speed for the animation (same for each balance)

        const movingPart = $(this).find($(".moving-part"));

        const startDegree = 0;
        const finalDegree = isRightValChecked()
            ? $(movingPart).data("right-degree")
            : $(movingPart).data("left-degree");

        // Animation starts from startDegree to finalDegree
        $({ deg: startDegree }).animate(
            { deg: finalDegree },
            {
                duration: speed,
                step: function (now) {
                    $(movingPart).attr(
                        "transform",
                        "rotate(" + now + ", 330, 240)"
                    );
                    $(".circle-untreated").attr(
                        "transform",
                        "rotate(" + -now + ", 90, 190)"
                    );
                    $(".circle-treated").attr(
                        "transform",
                        "rotate(" + -now + ", 585, 190)"
                    );
                },
            }
        );
    });
}

/**
 * Get a boolean to know if the right or left eye has been checked according to the toggle
 * @returns right eye = true | left eye = false
 */
function isRightValChecked() {
    return document.getElementById("right-eye-myopia-help-tab").checked;
}

function handleMyopiaManagementHelpSection() {
    const button = document.querySelector(
        "#collapse-myopia-management-help-button"
    );
    const inputs = document.querySelectorAll("input[name=eye-myopia-help]");

    if (button) {
        button.addEventListener("click", () => {
            setTimeout(() => {
                loadManagementHelpSectionAnimations();
            }, 500);
        });
    }

    inputs.forEach((input) => {
        input.addEventListener("input", () => {
            loadManagementHelpSectionAnimations();
        });
    });
}

function loadManagementHelpSectionAnimations() {
    loadSeeSawBalance();
    loadCircleProgressBar();
}

function initPatientLanguageDropdown() {
    const toggle = document.getElementById("languageDropdownToggle");
    const menu = document.getElementById("languageDropdownMenu");
    const chevron = document.querySelector(".language-dropdown-toggle-icon");

    toggle?.addEventListener("click", function () {
        toggle.classList.toggle("open");
        menu.classList.toggle("show");
        chevron.classList.toggle("rotated");
    });

    menu?.addEventListener("click", function (e) {
        const qrUrl = document
            .getElementById("languageDropdown")
            .getAttribute("data-qr-url");
        if (e.target.classList.contains("language-option-item")) {
            const languageCode = e.target.getAttribute("data-value");
            const isSelected =
                e.target.getAttribute("data-selected") === "true";

            // Prevent request if already selected
            if (isSelected) {
                return;
            }

            if (languageCode) {
                const url = `${qrUrl}/report/change-language`;
                const form = document.createElement("form");
                form.method = "POST";
                form.action = url;

                const input = document.createElement("input");
                input.type = "hidden";
                input.name = "patient_report_language";
                input.value = languageCode;

                form.appendChild(input);
                document.body.appendChild(form);
                form.submit();
            }
        }
    });
}

/**
 * On Load : Show the card according to the hash contains in the URL
 */
function launchShowCard() {
    const urlHash = getHashInURL();
    const bodyCard = document.querySelector(`${urlHash}`);

    // If there is a body card, we display it, otherwise we scroll to the top of the page
    if (bodyCard) {
        displayCard(bodyCard);
        scrollToCollapsible(computeCollapsibleOffset(bodyCard));
    } else {
        scrollToTop();
    }
}

/**
 * Remove the hash (#) from the URL
 */
function removeHashFromURL() {
    setTimeout(function () {
        window.history.replaceState(
            {},
            document.title,
            window.location.href.split("#")[0]
        );
    }, 200); // after 200 milliseconds to fix the bug (otherwise the hash is not removed)
}

/**
 * Scroll to the top of the page
 */
function scrollToTop() {
    $("html, body").animate(
        {
            scrollTop: 0,
        },
        200
    );
}

/**
 * Get the hash in the URL
 * Hash (#) is the href that indicates which body card have to be opened
 * @returns #...
 */
function getHashInURL() {
    // If no hash in the URL, return null
    if (location.href.lastIndexOf("#") < 0) {
        return null;
    }
    return location.href.substring(location.href.lastIndexOf("#"));
}

/**
 * Show or Hide the card
 * @param {HTMLElement} bodyCard
 */
function displayCard(bodyCard) {
    const wrapper = bodyCard.closest(".report-wrapper");

    if (!bodyCard.classList.contains("show")) {
        bodyCard.classList.add("show");
        wrapper.classList.add("show-wrapper");
    } else {
        bodyCard.classList.remove("show");
        wrapper.classList.remove("show-wrapper");
        removeHashFromURL();
    }
}

/**
 * On Click : Show or Hide the Read more (the body-read-more)
 * @param {*} header
 */
function displayReadMore(header) {
    const target = $(header).data("target");
    if ($(header).hasClass("show")) {
        $(header).removeClass("show");
        $(target).removeClass("show");
    } else {
        $(header).addClass("show");
        $(target).addClass("show");
    }
}

/**
 * Check if target id matches with element id.
 * @param {string} targetId
 * @param {string} elementId
 * @returns {boolean}
 */
function isCurrentTarget(targetId, elementId) {
    return targetId && targetId === elementId;
}

/**
 * Init the event listener
 */
function initCollapsibles() {
    const collapsibles = document.querySelectorAll(".accordion-item-body");
    let previousCollapsible;

    collapsibles.forEach((collapsible) => {
        const wrapper = collapsible.closest(".report-wrapper");

        collapsible.addEventListener("show.bs.collapse", (event) => {
            if (isCurrentTarget(event.target?.id, collapsible.id)) {
                wrapper.classList.add("show-wrapper");
            }
        });

        collapsible.addEventListener("hide.bs.collapse", (event) => {
            if (isCurrentTarget(event.target?.id, collapsible.id)) {
                wrapper.classList.remove("show-wrapper");
                previousCollapsible = collapsible;
            }
        });

        collapsible.addEventListener("shown.bs.collapse", (event) => {
            if (isCurrentTarget(event.target?.id, collapsible.id)) {
                const test =
                    previousCollapsible == null ||
                    computeCollapsibleOffset(previousCollapsible) >
                        computeCollapsibleOffset(collapsible);
                scrollToCollapsible(
                    computeCollapsibleOffset(collapsible),
                    test
                );
            }
        });

        collapsible.addEventListener("hidden.bs.collapse", (event) => {
            if (isCurrentTarget(event.target?.id, collapsible.id)) {
                scrollToCollapsible(
                    computeCollapsibleOffset(collapsible),
                    true
                );
            }
        });
    });

    $(".header-read-more").on("click", function () {
        displayReadMore(this);
    });

    launchShowCard();
}

/**
 *
 * @param {HTMLElement} collapsible
 * @returns {number}
 */
function computeCollapsibleOffset(collapsible) {
    return collapsible.closest(".report-wrapper").offsetTop - 5;
}
/**
 * Scrolls the page to the given scroll offset.
 * The behavior is instant when the scroll position is past halfway of the body height to avoid 'jumpy' motions caused by height difference.
 * @param {number} scrollOffset
 */
function scrollToCollapsible(scrollOffset, isSmooth = true) {
    const scrollBehaviour = isSmooth ? "smooth" : "instant";

    window.scroll({
        top: scrollOffset,
        left: 0,
        behavior: scrollBehaviour,
    });
}

window.addEventListener("load", () => {
    initCollapsibles();
    initPatientLanguageDropdown();
    handleMyopiaManagementHelpSection();
    loadManagementHelpSectionAnimations();
    openPromptModal();
    openCopyReportModal();
});
